export default "__VITE_ASSET__aO6hG$3j__"